import { useAppInfo } from "@src/appV2/lib/index";
import { type HcfTimeclockComplianceRollout } from "@src/appV2/Shifts/Shift/ShiftState/types";
import {
  checkIsHcfTimeclockComplianceEnabled,
  checkIsHcfTimeclockComplianceEnabledWithVideo,
} from "@src/appV2/Shifts/utils/checkIsHcfTimeclockComplianceEnabled";
import { useMemo } from "react";

interface UseIsVideoProofTimeclockComplianceEnabledResult {
  isTimeclockComplianceVideoProofEnabled: boolean | undefined;
  isLoading: boolean;
}

export function useIsTimeclockComplianceVideoProofEnabled(
  hcfTimeclockComplianceRollout?: HcfTimeclockComplianceRollout
): UseIsVideoProofTimeclockComplianceEnabledResult {
  const { appInfo, isLoading } = useAppInfo();

  const isTimeclockComplianceVideoProofEnabled = useMemo(() => {
    if (isLoading) {
      return undefined;
    }

    const isEnabled = checkIsHcfTimeclockComplianceEnabled({
      hcfTimeclockComplianceRollout,
      appInfo,
    });

    const isEnabledWithVideo = checkIsHcfTimeclockComplianceEnabledWithVideo({
      hcfTimeclockComplianceRollout,
      appInfo,
    });

    return isEnabled && isEnabledWithVideo;
  }, [hcfTimeclockComplianceRollout, appInfo, isLoading]);

  return {
    isTimeclockComplianceVideoProofEnabled,
    isLoading,
  };
}
